module.exports = {
    namespace: 'projects',
    da: {
        status: {
            'project-created': 'Projektet er blevet oprettet',
            'project-clarification': 'Projektet bliver afklaret',
            'customer-closed-project': 'Projektet er blevet annulleret af kunden',
            'employee-closed-project': 'Projektet er blevet annulleret af medarbejder',
            'student-closed-project': 'Projektet er blevet annulleret af den studerende',
            'project-offer-posted': 'Den studerende har afgivet et tilbud',
            'project-offer-accepted': 'Kunden har accepteret tilbuddet',
            'project-finalized': 'Projektet er afsluttet af den studerende',
        },
        events: {
            'project-created': 'Projektet er blevet oprettet',
            'project-clarification': 'Projektet bliver afklaret',
            'employee-closed-project': 'Projektet er blevet annulleret af medarbejder',
            'customer-closed-project': 'Projektet er blevet annulleret af kunden',
            'student-closed-project': 'Projektet er blevet annulleret af den studerende',
            'project-price-offer-posted': 'Den studerende har afgivet et tilbud',
            'project-price-offer-edited': 'Den studerende har ændret sit tilbud',
            'project-price-offer-accepted': 'Kunden har accepteret tilbuddet',
            'project-finalized': 'Projektet er afsluttet af den studerende',
        },
    },

    en: {
        status: {
            'project-created': 'Project created',
        },
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/projects/locales/index.js